module.exports = __webpack_public_path__ + "static/media/settings-outline.7bbfa203.svg";